import React from "react";
function Error() {
  return <h3 style={{color: 'red'}}>Error Occured! Sorry for the inconvenience. Please try again later.</h3>;
}

export default Error;
